module.exports = __webpack_public_path__ + "img/ayrton-interna.24daef1e.png";